/* ==========================================================================
   Dogs Supreme - Global data-event Tracker
   SA-W2 Pre-Build (Stand 2026-05-28)
   Activation: KW23 post Bundle-Pilot-T+7-Verdict (~04.06.2026)

   Zweck:
   - Single document-level click listener (event delegation).
   - Erfasst ALLE Elemente mit data-event="..." Attribut.
   - Mappt auf GA4-Events ueber Namespace-Klassifikator
     (bundle_atc, site_atc, ai_bridge, amp_pdp_link,
      external_brand_link, existing_cta, section_cta).
   - Pushes nach dataLayer fuer GTM-Pickup.
   - Consent-gated via Google Consent Mode v2 (analytics_storage).
   - Try/catch um alles, Tracking darf nie UX brechen.
   - Anti-Duplicate: ignoriert data-ds-track (von ds-cart-tracking.js abgedeckt).
   - Throttle: 200ms pro identischem data-event Wert, um Doppel-Clicks zu filtern.

   Loading-Order:
   - Wird via snippet 'ds-global-event-tracker.liquid' direkt vor
     'ds-cart-tracking' in layout/theme.liquid eingebunden.
   - 'defer' attribute -> laeuft nach DOM-Parse, vor DOMContentLoaded-Listener.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__dsGlobalEventTrackerInstalled) return;
  window.__dsGlobalEventTrackerInstalled = true;

  /* ----------------------------------------------------------------------
     Config
     ---------------------------------------------------------------------- */
  var DEBUG = false; // Set to true in dry-run (console.log every push).
  var THROTTLE_MS = 200;
  var lastFired = Object.create(null); // event_value -> ts

  /* ----------------------------------------------------------------------
     Consent + push helpers (mirrors ds-cart-tracking.js patterns)
     ---------------------------------------------------------------------- */
  function consentGranted() {
    try {
      var gtd = window.google_tag_data;
      var ent = gtd && gtd.ics && gtd.ics.entries;
      if (!ent || !ent.analytics_storage) return false;
      var a = ent.analytics_storage;
      var updateGranted = a.update === 'granted' || a.update === true;
      var defaultGranted = a.default === 'granted' || a.default === true;
      return updateGranted || (a.update === undefined && defaultGranted);
    } catch (e) { return false; }
  }

  function pushEvent(name, params) {
    if (!consentGranted()) {
      if (DEBUG) console.log('[DS-Global-Tracker] consent denied, skip:', name);
      return;
    }
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: name };
      if (params) {
        for (var k in params) {
          if (params.hasOwnProperty(k) && params[k] !== null && params[k] !== undefined) {
            payload[k] = params[k];
          }
        }
      }
      window.dataLayer.push(payload);
      if (DEBUG) console.log('[DS-Global-Tracker] push:', payload);
    } catch (e) {
      console.warn('[DS-Global-Tracker] pushEvent error:', name, e);
    }
  }

  /* ----------------------------------------------------------------------
     Namespace classifier (mirror of Python sa_w2_data_event_inventory.py)
     ---------------------------------------------------------------------- */
  function classify(eventValue) {
    if (!eventValue || typeof eventValue !== 'string') return 'unclassified';
    var v = eventValue.trim();
    if (v === 'click_bundle_atc') return 'bundle_atc';
    if (v === 'click_atc') return 'site_atc';
    if (v.indexOf('ai_bridge_click_') === 0) return 'ai_bridge';
    if (v.indexOf('click_amp_pdp_') === 0) return 'amp_pdp_link';
    if (v.indexOf('existing_cta_') === 0) return 'existing_cta';
    if (v.indexOf('section_') === 0 && v.indexOf('_cta_') !== -1) return 'section_cta';
    if (v.indexOf('click_') === 0
        && v.indexOf('click_amp_pdp_') !== 0
        && v !== 'click_atc'
        && v !== 'click_bundle_atc') {
      return 'external_brand_link';
    }
    return 'unclassified';
  }

  /* ----------------------------------------------------------------------
     Common-field builder (Page-Template, Path, etc.)
     ---------------------------------------------------------------------- */
  function pageTemplate() {
    try {
      var cls = document.body && document.body.className ? document.body.className : '';
      var m = cls.match(/template-[a-z0-9_-]+/);
      return m ? m[0] : '';
    } catch (e) { return ''; }
  }

  function truncDocTitle() {
    try {
      var t = document.title || '';
      return t.length > 60 ? t.slice(0, 60) : t;
    } catch (e) { return ''; }
  }

  function commonFields(el, eventValue) {
    return {
      event_label: eventValue,
      event_value: eventValue,
      page_template: pageTemplate(),
      source_page: location.pathname || '',
      source_article: truncDocTitle(),
      tag_name: (el.tagName || '').toLowerCase()
    };
  }

  function targetHref(el) {
    try {
      if (el.tagName && el.tagName.toLowerCase() === 'a' && el.href) return el.href;
      var a = el.closest && el.closest('a[href]');
      return a ? a.href : null;
    } catch (e) { return null; }
  }

  function dataAttr(el, key) {
    try {
      var v = el.getAttribute('data-' + key);
      return (v === null || v === '') ? null : v;
    } catch (e) { return null; }
  }

  /* ----------------------------------------------------------------------
     Per-namespace event builders
     ---------------------------------------------------------------------- */
  function buildBundleAtc(el, ev) {
    return {
      name: 'bundle_atc_click',
      params: Object.assign(commonFields(el, ev), {
        event_category: 'bundle',
        bundle_id: dataAttr(el, 'bundle-id'),
        bundle_total: dataAttr(el, 'bundle-total'),
        bundle_components: dataAttr(el, 'bundle-components'),
        product_id: dataAttr(el, 'product-id'),
        product_handle: dataAttr(el, 'product-handle'),
        product_type: dataAttr(el, 'product-type')
      })
    };
  }

  function buildSiteAtc(el, ev) {
    var section = null;
    try {
      var sec = el.closest && el.closest('section, form');
      section = sec ? (sec.getAttribute('data-section-type') || sec.getAttribute('id') || sec.tagName.toLowerCase()) : null;
    } catch (e) {}
    return {
      name: 'add_to_cart_intent',
      params: Object.assign(commonFields(el, ev), {
        event_category: 'pdp_atc',
        product_id: dataAttr(el, 'product-id'),
        product_handle: dataAttr(el, 'product-handle'),
        product_price: dataAttr(el, 'product-price'),
        product_type: dataAttr(el, 'product-type'),
        source_section: section
      })
    };
  }

  function buildAiBridge(el, ev) {
    var slug = ev.replace(/^ai_bridge_click_/, '');
    var parts = slug.split('_');
    var topic = parts.length > 0 ? parts[0] : '';
    var target = parts.length > 1 ? parts[parts.length - 1] : '';
    return {
      name: 'ai_bridge_click',
      params: Object.assign(commonFields(el, ev), {
        event_category: 'ai_bridge',
        bridge_slug: slug,
        bridge_topic: topic,
        target_product: target,
        target_href: targetHref(el)
      })
    };
  }

  function parseUtmCampaign(href) {
    if (!href) return null;
    try {
      var url = new URL(href, location.origin);
      return url.searchParams.get('utm_campaign');
    } catch (e) { return null; }
  }

  function buildAmpPdpLink(el, ev) {
    var slug = ev.replace(/^click_amp_pdp_/, '');
    var href = targetHref(el);
    return {
      name: 'amp_pdp_link_click',
      params: Object.assign(commonFields(el, ev), {
        event_category: 'amp_pdp_link',
        link_slug: slug,
        utm_campaign: parseUtmCampaign(href),
        target_href: href
      })
    };
  }

  function buildExternalBrand(el, ev) {
    // Pattern: click_<brand>_<context-segments>_<position>
    var rest = ev.replace(/^click_/, '');
    var segs = rest.split('_');
    var brand = segs.length > 0 ? segs[0] : '';
    var position = segs.length > 1 ? segs[segs.length - 1] : '';
    var context = segs.length > 2 ? segs.slice(1, -1).join('_') : '';
    return {
      name: 'external_brand_click',
      params: Object.assign(commonFields(el, ev), {
        event_category: 'external_brand_link',
        brand: brand,
        context: context,
        position: position,
        target_href: targetHref(el)
      })
    };
  }

  function buildExistingCta(el, ev) {
    var ctaId = ev.replace(/^existing_cta_/, '');
    return {
      name: 'cta_click',
      params: Object.assign(commonFields(el, ev), {
        event_category: 'existing_cta',
        cta_id: ctaId,
        target_href: targetHref(el)
      })
    };
  }

  function buildSectionCta(el, ev) {
    // Pattern: section_<x>_cta_<position>
    var match = ev.match(/^section_(.+?)_cta_(.+)$/);
    var section = match ? match[1] : '';
    var position = match ? match[2] : '';
    return {
      name: 'cta_click',
      params: Object.assign(commonFields(el, ev), {
        event_category: 'section_cta',
        cta_section: section,
        cta_position: position,
        target_href: targetHref(el)
      })
    };
  }

  function buildUnclassified(el, ev) {
    return {
      name: 'data_event_unclassified',
      params: Object.assign(commonFields(el, ev), {
        event_category: 'unclassified',
        target_href: targetHref(el)
      })
    };
  }

  var BUILDERS = {
    bundle_atc: buildBundleAtc,
    site_atc: buildSiteAtc,
    ai_bridge: buildAiBridge,
    amp_pdp_link: buildAmpPdpLink,
    external_brand_link: buildExternalBrand,
    existing_cta: buildExistingCta,
    section_cta: buildSectionCta,
    unclassified: buildUnclassified
  };

  /* ----------------------------------------------------------------------
     Throttle
     ---------------------------------------------------------------------- */
  function shouldFire(eventValue) {
    var now = Date.now();
    var last = lastFired[eventValue] || 0;
    if (now - last < THROTTLE_MS) {
      if (DEBUG) console.log('[DS-Global-Tracker] throttled:', eventValue);
      return false;
    }
    lastFired[eventValue] = now;
    return true;
  }

  /* ----------------------------------------------------------------------
     Click delegation
     ---------------------------------------------------------------------- */
  function handleClick(e) {
    try {
      // Find closest element with data-event up to 4 ancestors (Defensive).
      var el = e.target;
      var levels = 0;
      while (el && el !== document && levels < 6) {
        if (el.nodeType === 1 && el.hasAttribute && el.hasAttribute('data-event')) break;
        el = el.parentNode;
        levels++;
      }
      if (!el || !el.hasAttribute || !el.hasAttribute('data-event')) return;

      var ev = el.getAttribute('data-event');
      if (!ev) return;

      if (!shouldFire(ev)) return;

      var ns = classify(ev);
      var builder = BUILDERS[ns] || buildUnclassified;
      var built = builder(el, ev);
      if (!built) return;

      pushEvent(built.name, built.params);
    } catch (err) {
      console.warn('[DS-Global-Tracker] click handler error:', err);
    }
  }

  /* ----------------------------------------------------------------------
     Install
     ---------------------------------------------------------------------- */
  function install() {
    try {
      document.addEventListener('click', handleClick, { passive: true, capture: true });
      if (DEBUG) console.log('[DS-Global-Tracker] installed v1.0.0');
    } catch (err) {
      console.warn('[DS-Global-Tracker] install failed:', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install);
  } else {
    install();
  }

  /* ----------------------------------------------------------------------
     Test-Hook (only available in dry-run / Theme-Inspector)
     ---------------------------------------------------------------------- */
  window.__dsGlobalEventTrackerDebug = function (enable) {
    DEBUG = !!enable;
    return DEBUG ? 'DEBUG on' : 'DEBUG off';
  };

  window.__dsGlobalEventTrackerClassify = classify;

})();
